import * as z from "zod";

export const acceptPersonalizedSlipsTerms = {
  name: "acceptPersonalizedSlipsTerms" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
